module.exports = __webpack_public_path__ + "ec09ea5ece25101670bed5549d8a964b.svg";